module.exports = __webpack_public_path__ + "media/ok.45b625e4.wav";